export default __webpack_public_path__ + "locales/en/Settings.json?hash=fc85e55c691e0f2e07779695c49f9b41";